export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["мин"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сатып алу"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["үшін"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Белсенді"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жарнама сілтемесі"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мейкер ID"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сипаттама"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Таймаут"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Құрылу күні"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мен төлеймін"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мен аламын"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сауда лимиті"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Барлығы"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Саудалар"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ұсыныс ID"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Курс"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Шотты таңдаңыз"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Лимиттен тыс"])}
}